import React from 'react';
import '../style/modebar.css';

const MODES = [
  { key: 'films', label: 'Films', icon: '🎬' },
  { key: 'livres', label: 'Livres', icon: '📚' },
  { key: 'photos', label: 'Photos', icon: '📷' },
  { key: 'jeux', label: 'Jeux', icon: '🎮', soon: true },
];

function ModeBar({ mode, onChange }) {
  return (
    <nav className="bb-modebar" aria-label="Type de contenu">
      {MODES.map((m) => (
        <button
          key={m.key}
          type="button"
          className={`bb-mode${mode === m.key ? ' bb-mode--active' : ''}`}
          aria-pressed={mode === m.key}
          onClick={() => onChange(m.key)}
        >
          <span aria-hidden="true">{m.icon}</span>
          {m.label}
          {m.soon && <span className="bb-mode__soon">bientôt</span>}
        </button>
      ))}
    </nav>
  );
}

export { MODES };
export default ModeBar;
